export default __webpack_public_path__ + "9b5006e574f19fa8a1bdfd9f72673896.png";